import { render, staticRenderFns } from "./AppendDrawer.vue?vue&type=template&id=4790173c&"
import script from "./AppendDrawer.vue?vue&type=script&lang=ts&"
export * from "./AppendDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports